import { memo } from '@morphic-ts/common/es6/utils';
import { pipe } from 'fp-ts/function';
import * as t from 'io-ts';
import { iotsApplyConfig } from '../config';
import { IOTSType, IoTsURI } from '../hkt';
/**
 *  @since 0.0.1
 */
export const ioTsStrMapInterpreter = memo(() => ({
    _F: IoTsURI,
    strMap: (codomain, config) => env => pipe(codomain(env).type, type => new IOTSType(iotsApplyConfig(config)(t.record(t.string, type), env, { type }))),
    record: (domain, codomain, config) => env => ((domainType, codomainType) => new IOTSType(iotsApplyConfig(config)(t.record(domainType, codomainType), env, { domainType, codomainType })))(domain(env).type, codomain(env).type)
}));
